import { createSignal, type JSX } from 'solid-js'
import { ChevronDown } from './icons'

export function Collapsible(props: {
  title: string
  children: JSX.Element
  defaultOpen?: boolean
}) {
  const [open, setOpen] = createSignal(props.defaultOpen ?? false)

  return (
    <div
      class="gradient-outline bg-white/[0.53] transition-[border-radius] duration-300"
      classList={{ 'rounded-[32px]': open(), 'rounded-[20px]': !open() }}
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        class="flex w-full items-center justify-between px-6 py-4"
        aria-expanded={open()}
      >
        <span class="text-base font-bold leading-5 text-ink [text-shadow:0_0_5.5px_rgba(255,255,255,1)]">
          {props.title}
        </span>
        <ChevronDown
          class="size-5 text-ink transition-transform duration-300"
          classList={{ '-rotate-90': !open() }}
        />
      </button>
      <div
        class="grid transition-[grid-template-rows] duration-300 ease-out"
        style={{ 'grid-template-rows': open() ? '1fr' : '0fr' }}
      >
        <div class="overflow-hidden">
          <div class="px-6 pb-4 pt-2">{props.children}</div>
        </div>
      </div>
    </div>
  )
}
